let queue

const sendEvent = (e) => {
  if (window.google_tag_manager) {
    window.dataLayer.push(e)
  } else if (queue) {
    queue.push(e)
  } else {
    queue = [e]
    window.addEventListener('gtm_loaded', () => {
      queue.forEach((element) => {
        window.dataLayer.push(element)
      })
      queue = null
    })
  }
}

export { sendEvent }
